export const actionType = {
    MYDELIVERIES_REQUEST: 'MYDELIVERIES_REQUEST',
    MYDELIVERIES_SUCCESS: 'MYDELIVERIES_SUCCESS',
    MYDELIVERIES_FAILURE: 'MYDELIVERIES_FAILURE', 

    ADD_DELIVERY : 'ADD_DELIVERY'

    
};